import * as R from 'ramda';

import {translate} from 'iss/strings';

function translateEnum(path) {
  return R.compose(translate, R.concat(path+"."), (key) => key || "null");
}

export const translateRecurrenceType = translateEnum('domain.activatedEvaluation.recurrenceTypes');
export const translateEvaluationType = translateEnum('domain.activatedEvaluation.evaluationTypes');
export const translatePartyActivationType = translateEnum('domain.activatedEvaluation.partyActivationTypes');
export const translateActivationReportingStyle = translateEnum('domain.evaluationForm.activationReportingStyle');
export const translateSiteSize = translateEnum('domain.evaluationForm.siteSizes');
export const translateEventState = translateEnum('domain.evaluationEvent.eventStates');
export const translateEventAction = translateEnum('domain.evaluationEvent.eventActions');
export const translateEventCancelReason = translateEnum('domain.evaluationEvent.eventCancelReasons');
export const translateFormEvaluationContext = translateEnum('domain.formEvaluationContext');
export const translateAnswerVisibility = translateEnum('domain.answerVisibility');
export const translateSubsystemType = translateEnum('domain.subsystemType');
export const translateSystemStatus = translateEnum('domain.systemStatus');
export const translateFiilissVisibility = translateEnum('domain.fiilissVisibility');

export function translateWeekday(day) {
  const dayNames = translate('common.shortWeekDays');
  return dayNames[day-1];
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/domainTranslations.js